import React from 'react';
import CreateOrEditManualRefund from './CreateOrEditManualRefund';

const CreateRefund = () => {
  return (
    <div>
      <CreateOrEditManualRefund />
    </div>
  );
};

export default CreateRefund;
